import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { BlockPeriodTypeEnum } from '../../enums/meal-plan';
import { IIngredientCategory } from 'src/app/interfaces/database/database.interface';
import { Subject, takeUntil } from 'rxjs';
import { Store } from '@ngxs/store';
import { IngredientState } from 'src/app/models/ingredient';
import { MealTimeClass } from 'src/app/class/meal-plan/meal-time.class';
import { INGREDIENT_CATEGORIES_ICONS_B } from 'src/app/class/data';
@Component({
  selector: 'app-card-meal-plan-kanban',
  templateUrl: './card-meal-plan-kanban.component.html',
  styleUrls: ['./card-meal-plan-kanban.component.scss']
})
export class CardMealPlanKanbanComponent implements OnInit, OnChanges, OnDestroy {

  @Input() name: string;
  @Input() mealTime: MealTimeClass;

  @Output() remove: EventEmitter<MealTimeClass> = new EventEmitter<MealTimeClass>();
  @Output() edit: EventEmitter<MealTimeClass> = new EventEmitter<MealTimeClass>();

  private destroy$ = new Subject<void>();
  categories!: IIngredientCategory[];

  hour: Date = null;
  blockPeriodTypeEnum = BlockPeriodTypeEnum;

  periodTypesIconsMap = {};

  iconsRoute = './../../../assets/images/icons/ingredients_group/';
  iconsName = INGREDIENT_CATEGORIES_ICONS_B;

  constructor(
    private store: Store
  ) { }


  ngOnInit(): void {
    this.periodTypesIconsMap[this.blockPeriodTypeEnum.FOOD_GROUP] = './../../../assets/images/icons/icons8-food-100-2.png';
    this.periodTypesIconsMap[this.blockPeriodTypeEnum.INDIVIDUAL] = './../../../assets/images/icons/icons8-tomato-100.png';
    this.periodTypesIconsMap[this.blockPeriodTypeEnum.INSTRUCTION] = './../../../assets/images/icons/icons8-book-100.png';

    this.store.select(IngredientState.getIngredientCategories).pipe(
      takeUntil(this.destroy$)
    ).subscribe(categories => this.categories = categories);
  }


  /**
   * Detecta cuando cambia la propiedad mealTime para determinar si se setea el horario o no
   * @param changes cambios
   */
  ngOnChanges(changes: SimpleChanges): void {
    if (!changes.mealTime) return;
    if (this.mealTime?.hasHour) {
      const date = new Date();
      date.setHours(this.mealTime?.time?.hour);
      date.setMinutes(this.mealTime?.time?.minute);
      this.hour = date;
    } else {
      this.hour = null;
    }
  }

  /**
   * Emite al componente padre cuando se quiere eliminar un block period.
   */
  onEmitRemove(): void {
    this.remove.emit(this.mealTime);
  }

  /**
   * Emite al componente padre cuando se quiere editar un block period.
   */
  onEmitEdit(): void {
    this.edit.emit(this.mealTime);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
